(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('recaptcha', ["$q", "http", function ($q, http) {
        var initialized = false;
        var loaderDefer = null;
        var lastWidget = null;
        var sitekey = null;
        window.onRecaptchaLibLoaded = function () {
            initializationSuccess();
        };
        var verificationDefer = null;
        function onRecaptchaVerified(response) {
            if (verificationDefer) {
                verificationDefer.resolve(response);
                verificationDefer = null;
            }
            window.grecaptcha.reset(lastWidget);
        }
        var enabled = false;
        function initializationSuccess() {
            initialized = true;
            if (loaderDefer) {
                loaderDefer.resolve(enabled);
                loaderDefer = null;
            }
        }
        function loadRecaptchaScript() {
            var rs = document.createElement('script');
            rs.type = 'text/javascript';
            rs.async = true;
            rs.defer = true;
            rs.onerror = function () {
                loaderDefer.reject();
                loaderDefer = null;
            };
            rs.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLibLoaded&render=explicit';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(rs, s);
        }
        return {
            init: function () {
                if (initialized) {
                    return $q.when(enabled);
                }
                if (!loaderDefer) {
                    loaderDefer = $q.defer();
                    http.get('/api/v1/generic/recaptcha_config').then(function (response) {
                        if (!response.data || !response.data.key) {
                            enabled = false;
                            initializationSuccess();
                        } else {
                            enabled = true;
                            sitekey = response.data.key;
                            loadRecaptchaScript();
                        }
                    }).catch(function () {
                        enabled = false;
                        initializationSuccess();
                    });
                }
                return loaderDefer.promise;
            },
            render: function (element) {
                if (!initialized) {
                    return null;
                }
                lastWidget = window.grecaptcha.render(element, {
                    sitekey: sitekey,
                    size: 'invisible',
                    callback: onRecaptchaVerified
                });
                return lastWidget;
            },
            destroyed: function (widgetId) {
                if (widgetId && widgetId === lastWidget) {
                    lastWidget = null;
                }
            },
            execute: function () {
                if (verificationDefer) {
                    verificationDefer.reject();
                }
                verificationDefer = $q.defer();
                window.grecaptcha.execute(lastWidget);
                return verificationDefer.promise;
            },
            enabled: function () {
                return enabled;
            }
        };
    }]);
}());